/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { PublicClientApplication } from "@azure/msal-browser";
import { B2CClientID, B2CDomainAuthority, B2CRedirectUrl, B2CSessionScope, B2CSignupSigninAuthority } from "src/utils/config";

const cliend_id = B2CClientID;
const domain_authority = B2CDomainAuthority;
const redirect_url = B2CRedirectUrl;
const session_scope = B2CSessionScope;
const signup_signin_authority = B2CSignupSigninAuthority;

const post_logout_redirect_uri = signup_signin_authority + "/oauth2/v2.0/logout?post_logout_redirect_uri=" + redirect_url;

export const msalConfig:any = {
  auth: {
    clientId: cliend_id,
    authority: signup_signin_authority,
    knownAuthorities: [domain_authority],
    redirectUri: redirect_url,
    postLogoutRedirectUri: post_logout_redirect_uri
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" to save cache in cookies
  }
};

// Scopes you add here will be prompted for consent during login
export const loginRequest:any = {
    scopes: ["openid", "offline_access", session_scope]
};

export const msalInstance = new PublicClientApplication(msalConfig);

/*
let msalLoading = true;

msalInstance.handleRedirectPromise()
  .then(result => {
     msalLoading = false;
     console.log("handleRedirectPromise", result);

     if (result) {
      // If result is truthy, your app returned from a redirect operation,
      // and it completed successfully
     } else {
       // If .then was called but result is falsey, that means your app is not returning
       // from a redirect operation (e.g. user visiting the site for the first time)
     }
  })
  .catch(error => {
     msalLoading = false;
     console.log("handleRedirectPromise error", error);
     // If .catch is called, this means your app was returning from a redirect operation
     // and an error occurred.
   });
   */